// extracted by mini-css-extract-plugin
module.exports = {"warning-message":"Message_warning-message__KnSBc"};